<template>
  <v-menu v-model="open" class="filter-menu" left offset-x :close-on-content-click="false">
    <template v-slot:activator="{ on }">
      <v-badge color="marca-1" :value="filtersQuantity" :content="filtersQuantity" overlap>
        <mf-button color="cinza-0" icon="filter_list" type="icon" v-on:click.native="on.click" />
      </v-badge>
    </template>

    <v-card width="285px">
      <v-card-text>
        <p class="title">Filtros</p>
        <v-row>
          <v-col>
            <label class="detail-title">Lojas</label>
            <mf-select-units-dialog
              solo
              :selected-units.sync="filters.selectedUnits"
              check-all-units-on-init
              hide-details
              required
              single-line
              :units="units"
              :tag-list="tagList"
              :group-list="unitsGroups"
              hide-ecommerce-configuration
              @change="$emit('update-data')"
            />
          </v-col>
          <v-col cols="12">
            <label class="detail-title">Com imagem</label>
            <v-select
              v-model="filters.images"
              :items="[
                { text: 'Sim', val: true },
                { text: 'Não', val: false },
                { text: 'Todos', val: 'Todos' },
              ]"
              outlined
              item-value="val"
              item-text="text"
              hide-details
              @change="$emit('update-data', true)"
            />
          </v-col>
        </v-row>
        <mf-action-buttons
          :primary-button="{
            text: 'Fechar',
            action: () => (open = false),
            isVisible: true,
          }"
          :cancel-button="{
            text: 'Limpar',
            action: clearFilters,
            isVisible: true,
          }"
        />
      </v-card-text>
    </v-card>
  </v-menu>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'ProductsFilter',
  props: {
    filterType: {
      type: String,
      default: 'default',
    },
    options: {
      type: Object,
      required: true,
    },
    filters: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    open: false,
  }),
  computed: {
    ...mapGetters(['units', 'tagList', 'unitsGroups']),
    filtersQuantity() {
      return Object.keys(this.filters).reduce((counter, filter) => {
        if ((!!this.filters[filter].length && filter !== 'images') || (filter === 'images' && this.filters[filter] !== 'Todos')) counter += 1
        return counter
      }, 0)
    },
  },
  methods: {
    applyFilters() {
      this.options.page = 1
      this.open = false
      this.$emit('get-data')
    },
    clearFilters() {
      this.open = false
      this.$emit('clear-filters', this.filterType)
    },
  },
}
</script>
